import { GroupChannel } from "@sendbird/chat/groupChannel";
import { useMemo } from "react";

export function useIsChannelOnline(
  channel: GroupChannel | undefined,
  userId: string,
) {
  return useMemo(() => {
    if (!channel) return false;

    const otherMembers = channel.members.filter(
      (member) => member.userId !== userId,
    );

    // Check if any other member is online or if someone is typing
    return (
      otherMembers.some((member) => member.connectionStatus === "online") ||
      channel.isTyping
    );
  }, [channel?.members, channel?.isTyping, userId]);
}
